import { useTranslation } from 'react-i18next'
import { InvoicesSection } from '../features/invoices/InvoicesSection'
import { PageHeader } from '../components/PageHeader'

export function InvoicesPage() {
  const { t } = useTranslation()

  return (
    <div className="p-4 sm:p-8">
      <PageHeader title={t('invoices.title')} subtitle={t('invoices.subtitle')} />
      <InvoicesSection />
    </div>
  )
}
